import { useEffect, useState } from "react"
import DelayedLinkWithFadeout from "../utils/DelayedLinkWithFadeout"
// import { invoke } from "@tauri-apps/api"
import { listen } from "@tauri-apps/api/event"

const PopupFooter = () => {
    const [counter, setCounter] = useState(60)

    // useEffect(() => {
    //     const counterInterval = setInterval(
    //         () => invoke("mostra_tempo", { cont: counter }).then(() => setCounter(counter => counter - 1))
    //         , 1000)
    //     return () => {
    //         clearInterval(counterInterval);
    //         if (counter <= 0) {
    //             window.location.href = '/totem';
    //         }
    //     }
    // })

    listen('inatividade', function() {
        setCounter(30)
    });

    listen('acordar', function() {
        setCounter(60)
    });

    listen('timeover', function() {
        window.location.href = process.env.REACT_APP_ROOT_FOLDER
        // invoke('fecha_janela')
    });

    return (
        <div className="p-2 bottom-0 left-0 fixed bg-slate-800 w-full z-10 grid grid-cols-[1fr_3fr_1fr]">
            <button onClick={() => {
                window.location.href = '/totem/atendimento'
                // invoke('fecha_janela')
                // invoke('clear_browser_data')
            }}
                className="justify-self-start col-start-1 py-1.5 text-2xl shadow-xl px-4 transition-colors bg-yellow-600 border align-center text-center active:bg-red-700 border-red-900 text-white rounded-lg font-semibold disabled:opacity-50"
            >
                <p className="align-middle">Atendimentos</p>
            </button>
            {/* {
                counter <= 30 && counter >= 0
                ? <button
                    onClick={() => setCounter(60)}
                    className="justify-self-start col-start-1 py-1.5 text-2xl shadow-xl px-4 transition-colors bg-yellow-600 border align-center text-center active:bg-yellow-700 border-yellow-900 text-white rounded-lg font-semibold disabled:opacity-50"
                >
                    <p className="align-middle">Estou Aqui</p>
                </button>
                : true
            } */}
            {
                counter <= 30 && counter >= 0
                    ? <div className="text-red-300 font-semibold self-center col-start-2 justify-self-center text-2xl blink">
                        INATIVIDADE DETECTADA! ATENDIMENTO SERÁ ENCERRADO EM BREVE
                    </div>
                    : <div className="text-yellow-300 font-semibold self-center col-start-2 justify-self-center text-2xl">
                    Clique em ENCERRAR para voltar à tela inicial
                </div>
            }
            <button onClick={() => {
                window.location.href = process.env.REACT_APP_ROOT_FOLDER
                // invoke('fecha_janela')
                // invoke('clear_browser_data')
            }}
                className="justify-self-end col-start-3 py-1.5 text-2xl shadow-xl px-4 transition-colors bg-red-600 border align-center text-center active:bg-red-700 border-red-900 text-white rounded-lg font-semibold disabled:opacity-50"
            >
                <p className="align-middle">Encerrar</p>
            </button>
            {/* <DelayedLinkWithFadeout
                to={'/'}
                className="justify-self-end col-start-3"
            >
                
            </DelayedLinkWithFadeout> */}
        </div>
    )
}

export default PopupFooter
